export default ({ request }) => ({
  orderBudgetListApi(data = {}) {
    return request({
      url: '/factory/reportBudget/list',
      method: 'post',
      data
    })
  },
  orderBudgetSaveApi(data = {}) {
    return request({
      url: '/factory/reportBudget/save',
      method: 'post',
      data
    })
  },
  orderBudgetDetailApi(data = {}) {
    return request({
      url: '/factory/reportBudget/detail',
      method: 'post',
      data
    })
  },
  orderBudgetDelApi(data = {}) {
    return request({
      url: '/factory/reportBudget/del',
      method: 'post',
      data
    })
  },
  orderBudgetAuditApi(data = {}) {
    return request({
      url: '/factory/reportBudget/audit',
      method: 'post',
      data
    })
  },
  orderBudgetCustomerSaveApi(data = {}) {
    return request({
      url: '/factory/report/budget/customer/save',
      method: 'post',
      data
    })
  },
  orderBudgetCustomerQuarterDelApi(data = {}) {
    return request({
      url: '/factory/report/budget/customer/quarter/del',
      method: 'post',
      data
    })
  },
  orderBudgetCustomerDetailApi(data = {}) {
    return request({
      url: '/factory/report/budget/customer/detail',
      method: 'post',
      data
    })
  },
})
